import axios from 'axios';
import { getToken } from './adalconfig';
import * as microsoftTeams from '@microsoft/teams-js';
import { Observable } from "rxjs";
import { getAccessToken } from './Services/authService';
import { apiUrl } from "./message";
const apiurl = `${apiUrl}` + "/api/CommunityData/";

const inTeams = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}
const getAuthToken = (): Observable<string> => {
    return Observable.create((observer: any) => {
        if (inTeams()) {
            microsoftTeams.initialize();
            microsoftTeams.initialize(async () => {
                microsoftTeams.getContext((userInfo: any) => {
                    observer.next(getAccessToken());
                })
            })
        }
        else
            observer.next(getToken());
    })
}

export const PostMembers = (members: Array<any>, groupid: string, type: string): Observable<any> => {
    return Observable.create((observer: any) => {
        getAuthToken().subscribe((token: string) => {
            axios.post(`${apiurl}`, { "members": members, "groupid": groupid, "type": type }, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then(res => {
                if (res.status === 200) {
                    observer.next(res);
                }
                else {
                    observer.next([]);
                }
            }).catch(res => {
                observer.next({ status: "Error", message: res });
            })

        })
    })
}

export const UpdateMembers = (members: Array<any>, groupid: string, type: string): Observable<any> => {
    return Observable.create((observer: any) => {
        getAuthToken().subscribe((token: string) => {
            axios.patch(`${apiurl}`, { "members": members, "groupid": groupid, "type": type, "id": members[0].id }, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then(res => {
                if (res.status === 200) {
                    observer.next(res);
                }
                else {
                    observer.next([]);
                }
            }).catch(res => {
                observer.next({ status: "Error", message: res });
            })

        })
    })
}

export const GetNominationTeams = (): Observable<any> => {
    return Observable.create((observer: any) => {
        getAuthToken().subscribe((token: string) => {
            axios.get(`${apiurl}GetNominationsTeams`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then(res => {
                if (res.status === 200) {
                    observer.next(res.data);
                }
                else {
                    observer.next([]);
                }
            }).catch(res => {
                observer.next({ status: "Error", message: res });
            })

        })
    })
}

export const GetAccountsMembersAndOwners = (groupid: string): Observable<any> => {
    return Observable.create((observer: any) => {
        getAuthToken().subscribe((token: string) => {
            axios.all([
                axios.get(`${apiurl}GetCommunityMembers/${groupid}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }),
                axios.get(`${apiurl}GetCommunityOwners/${groupid}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })])
                .then(res => {
                    if (res[0].status === 200 && res[1].status === 200) {
                        observer.next({ "members": res[0].data, "owners": res[1].data });
                    }
                    else {
                        observer.next({ "members": [], "owners": [] });
                    }
                }).catch(res => {
                    observer.next({ status: "Error", message: res });
                })

        })
    })
}

export const GetAccountsMembers = (groupid: string): Observable<any> => {
    return Observable.create((observer: any) => {
        getAuthToken().subscribe((token: string) => {
            axios.all([
                axios.get(`${apiurl}GetCommunityMembers/${groupid}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })])
                .then(res => {
                    if (res[0].status === 200) {
                        observer.next({ "members": res[0].data, });
                    }
                    else {
                        observer.next({ "members": [] });
                    }
                }).catch(res => {
                    observer.next({ status: "Error", message: res });
                })
        })
    })
}

export const GetAccountsOwners = (groupid: string): Observable<any> => {
    return Observable.create((observer: any) => {
        getAuthToken().subscribe((token: string) => {
            axios.all([
                axios.get(`${apiurl}GetCommunityOwners/${groupid}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })])
                .then(res => {
                    if (res[0].status === 200) {
                        observer.next({ "owners": res[0].data });
                    }
                    else {
                        observer.next({ "owners": [] });
                    }
                }).catch(res => {
                    observer.next({ status: "Error", message: res });
                })
        })
    })
}

export const ResendCredentials = (members: any): Observable<any> => {
    return Observable.create((observer: any) => {
        var membersNew: { to: any; username: any; pswd: any; userGUID: any; }[] = [];
        for (var j = 0; j < members.length; j++) {
            membersNew.push({
                "to": members[j].title,
                "username": members[j].userId,
                "pswd": members[j].tempPassword,
                "userGUID": members[j].userGUID
            });
        }
        getAuthToken().subscribe((token: string) => {
            axios.post(`${apiurl}ResendCredentials`, membersNew, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then(res => {
                if (res.status === 200) {
                    observer.next(res);
                }
                else {
                    observer.next([]);
                }
            }).catch(res => {
                observer.next({ status: "Error", message: res });
            })

        })
    })
}

export const ResendInvitaion = (members: any): Observable<any[]> => {
    return Observable.create((observer: any) => {
        var membersNew: { to: any; guestUrl: any; }[] = [];
        for (var j = 0; j < members.length; j++) {
            membersNew.push({
                "to": members[j].title,
                "guestUrl": members[j].guestInviteURL,
            });
        }
        getAuthToken().subscribe((token: string) => {
            axios.post(`${apiurl}ResendGuestInvite`, membersNew, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then(res => {
                if (res.status === 200) {
                    observer.next(res);
                }
                else {
                    observer.next([]);
                }
            }).catch(res => {
                observer.next({ status: "Error", message: res });
            })

        })
    })
}

export const RemoveMember = (id: any): Observable<any> => {
    return Observable.create((observer: any) => {
        getAuthToken().subscribe((token: string) => {
            axios.post(`${apiurl}BulkRemoveMember`, id, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then(res => {
                if (res.status === 200) {
                    observer.next(res);
                }
                else {
                    observer.next([]);
                }
            }).catch(res => {
                observer.next({ status: "Error", message: res });
            })

        })
    })
}
export const AcceptToc = (listid: string, IsAccept: boolean): Observable<any> => {
    return Observable.create((observer: any) => {
        axios.get(`${apiurl}Toc/${listid}/${IsAccept}`).then(res => {
            if (res.status === 200 || res.status === 204) {
                observer.next(res);
            }
            else {
                observer.next([]);
            }
        }).catch(res => {
            observer.next({ status: "Error", message: res });
        })

    })
}

export const GetAccountById = (id: string): Observable<any> => {

    return Observable.create((observer: any) => {
        axios.get(`${apiurl}GetAcountById/${id}`).then(res => {
            if (res.status === 200) {

                observer.next(res.data);
            }
            else {
                observer.next([]);
            }
        }).catch(res => {
            observer.next({ status: "Error", message: res });
        })

    })
}

